import { useContext, useState, useEffect } from "react";
import { Chip, Tooltip } from "@mui/material";
import { useTranslation } from "react-i18next";
import { formatKM } from "helpers/helpers"
import dayjs from 'dayjs';

interface Props {
    data: any;
    handleDeleteFilter: any;
    handleFilterLocationsClick: any;
}

const FilterChip = (props: Props) => {
    const [t] = useTranslation();
    const [filterData, setFilterData] = useState<any>(JSON.parse(JSON.stringify(props.data)));

    const isNumericStr = (s: string) => {
        const t = String(s).trim();
        if (t === "") return false;
        const n = Number(t);
        return Number.isFinite(n);
    };


    const toMillis = (s: any) => {
        // 统一从字符串/数字转换为“毫秒时间戳”
        if (s == null) return null;
        const t = String(s).trim();
        if (t === "") return null;

        const n = Number(t);
        if (!Number.isFinite(n)) return null;

        // 10位（秒） vs 13位（毫秒）通用处理：
        // 经验阈值：小于 1e12 基本可判断为秒级 Unix 时间戳
        const ms = Math.abs(n) < 1e12 ? n * 1000 : n;

        // 取整，避免小数秒/毫秒导致的非整数时间
        const msInt = Math.round(ms);
        return Number.isFinite(msInt) ? msInt : null;
    };

    const formatDate = (ms: any) => dayjs(ms).format('YYYY-MM-DD');

    const handleLabel = () => {
        let label = ""
        if (filterData.title === "topLocations") {
            label = filterData.value === "allLocations" ? t("locationSet.filterModal.allLocations") : t("locationSet.filterModal.topLocationsData", { data: filterData.value })
        } else {
            label = t("locationSet.filterModal." + filterData.title) + ": "
            if (filterData.type === "select") {
                if (filterData.title === "occupancy") {
                    label += filterData.value.map((item: string) => t("occupancyOptions." + item)).join(",")
                } else {
                    label += filterData.value.join(",")
                }
            } else if (filterData.type === "number") {
                const minRaw = (filterData.min || "").trim();
                const maxRaw = (filterData.max || "").trim();

                const minValid = isNumericStr(minRaw);
                const maxValid = isNumericStr(maxRaw);

                // 仅 min 有效
                if (minValid && !maxValid) {
                    label += `>${formatKM(minRaw)}`
                };

                // 仅 max 有效
                if (!minValid && maxValid) {
                    label += `<${formatKM(maxRaw)}`
                };

                // 两者都无效
                if (minValid && maxValid) {
                    label += `${formatKM(minRaw)}-${formatKM(maxRaw)}`;
                }
            } else if (filterData.type === "time") {
                const minMs = toMillis(filterData.min);
                const maxMs = toMillis(filterData.max);

                const minValid = minMs !== null;
                const maxValid = maxMs !== null;

                if (minValid && !maxValid) {
                    label += `>${formatDate(minMs)}`
                };
                if (!minValid && maxValid) {
                    label += `<${formatDate(maxMs)}`
                };

                // 两者都有效（不纠正顺序）
                if (minValid && maxValid) {
                    label += `${formatDate(minMs)}-${formatDate(maxMs)}`
                }
            }
        }

        return label
    }

    useEffect(() => {
        setFilterData(JSON.parse(JSON.stringify(props.data)))
    }, [props.data])

    return (<Chip
        label={handleLabel()}
        variant="outlined"
        icon={
            <Tooltip title={t("locationSet.uploadFilter")}>
                <div
                    onClick={(event) => props.handleFilterLocationsClick(event)}
                    className="material-icons"
                    style={{ cursor: "pointer", background: "#007934", color: "#fff", borderRadius: "50%", fontSize: "18px" }}
                >
                    more_horiz
                </div>
            </Tooltip>
        }
        onDelete={() => props.handleDeleteFilter()}
    />);
};

export default FilterChip;
